import { styled } from 'styled-components';

const SelectContainer = styled.div`
  * {
    word-break: break-all;
  }
`;

export default SelectContainer;
